import { generateRandomString } from 'utils/StringHelper';
import axios from 'axios';

class SSOService {
  authSso() {
    const state = generateRandomString(40);
    sessionStorage.setItem('state', state);
    const queryParams = new URLSearchParams({
      client_id: process.env.REACT_APP_SSO_CLIENT_ID,
      redirect_uri: `${process.env.REACT_APP_APP_URL}/api/auth/callback/sso`,
      response_type: 'code',
      scope: '',
      state: state
    }).toString();

    window.location.href = `${process.env.REACT_APP_SSO_CLIENT_URL}/oauth/authorize?${queryParams}`;
  }

  async getToken(code) {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_SSO_CLIENT_URL}/oauth/token`,
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: {
          client_id: process.env.REACT_APP_SSO_CLIENT_ID,
          client_secret: process.env.REACT_APP_SSO_CLIENT_SECRET,
          grant_type: 'authorization_code',
          code: code,
          redirect_uri: `${process.env.REACT_APP_APP_URL}/api/auth/callback/sso`
        }
      });
      return response;
    } catch (error) {
      return error.response.data;
    }
  }

  async getUserInfo(tokenType, accessToken) {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_SSO_CLIENT_URL}/api/user`,
        method: 'GET',
        headers: {
          'content-type': 'application/json',
          Authorization: `${tokenType} ${accessToken}`
        }
      });
      return response;
    } catch (error) {
      return error.response.data;
    }
  }

  async getKeyCloak(tokenType, accessToken) {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_SSO_CLIENT_URL}/api/keycloak-token`,
        method: 'GET',
        headers: {
          'content-type': 'application/json',
          Authorization: `${tokenType} ${accessToken}`
        }
      });
      return response;
    } catch (error) {
      return error.response.data;
    }
  }

  async logoutSso(token) {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_SSO_CLIENT_URL}/api/logout`,
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      return error;
    }
  }
}

export default new SSOService();
